export default __webpack_public_path__ + "static/media/magic-chest-close-tab.27a399b3.png";